import React from "react";
import {
  availability,
  contactEmail,
  githubUrl,
  location,
  projectInquiryUrl,
} from "../lib/contact";

export const FactsRow = () => (
  <ul className="facts-row" aria-label="Availability">
    <li className="facts-available">
      <span className="status-dot" aria-hidden="true" />
      {availability}
    </li>
    <li>{location}</li>
    <li>Building apps since 2014</li>
  </ul>
);

const ContactBand = () => (
  <section className="contact-band" aria-labelledby="contact-title">
    <div className="contact-lead">
      <p className="eyebrow" id="contact-title">
        Contact
      </p>
      <h2>Have a mobile app or product prototype in mind?</h2>
      <p className="contact-meta">
        {availability} · {location}
      </p>
    </div>
    <div className="contact-paths">
      <div className="contact-path">
        <span>Start a project</span>
        <a href={projectInquiryUrl}>
          {contactEmail}
        </a>
      </div>
      <div className="contact-path">
        <span>Hiring full-time?</span>
        <a href={githubUrl} target="_blank" rel="noopener noreferrer">
          See my code on GitHub
        </a>
      </div>
    </div>
  </section>
);

export default ContactBand;
